module.exports = __webpack_public_path__ + "static/media/ground-tx-lg.02ec95a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/ground-tx-lg.jpg
// module id = 605
// module chunks = 0